<template>
    <template v-for="(etape, xkey) in etapes">
        <div v-if="etape && Object.keys(etape).length" v-show="etapeActuelle === xkey" class="bg-white p-4 rounded-xs shadow-md">
            <p class="text-xs">{{ etapeActuelle + 1 }} / {{ etapes.length }}</p>
            <div class="w-full md:w-2/3 lg:w-1/2 m-auto flex flex-col my-4">
                <h2 class="text-center font-bold text-2xl" v-html="__('etape_'+etape.nom)"></h2>
                <p class="text-center" v-html="__('etape_'+etape.nom+'_chapeau')"></p>
                <template v-for="(option, vkey) in etape.options">
                    <template v-if="showOption[etape.id][option.id]">
                        <template v-if="option.type === 'button'">
                            <div>
                                <label v-if="__(option.name)" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <div class="flex">
                                    <template v-for="(enfant) in option.enfants">
                                        <div class="w-1/2 text-center mx-4">
                                            <button class="inline-block px-6 py-2 text-base
                                                font-medium leading-4 text-center text-white
                                                uppercase transition bg-cavilam-primary rounded
                                                shadow ripple hover:shadow-lg hover:bg-blue-800
                                                focus:outline-none"
                                                v-html="__(enfant.name)"
                                                @click="choisirOption(xkey, vkey, enfant.id)">
                                            </button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="option.type === 'text'">
                            <div class="text-xs my-2">
                                <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <input :id="'option_'+option.id" v-model="form.etapes[xkey][vkey].value" type="text" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4">
                            </div>
                        </template>
                        <template v-else-if="option.type === 'label'">
                            <div class="text-xs my-2">
                                <label class="block text-center text-sm font-semibold text-gray-600 py-2" v-html="__(option.name)"></label>
                            </div>
                        </template>
                        <template v-else-if="option.type === 'textarea'">
                            <div class="text-xs my-2" v-if="option.id === 12">
                                <div v-if="etape.id == 1 && form.etapes[0][1]">
                                    <div v-if="form.etapes[0][1].id === 4 && (form.etapes[0][1].value == 5 || form.etapes[0][1].value == 6)">
                                        <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                        <textarea :id="'option_'+option.id" v-model="form.etapes[xkey][vkey].value" class="text-xs appearance-none block w-full text-grey-darker rounded-sm"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="text-xs my-2" v-else>
                                <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <textarea :id="'option_'+option.id" v-model="form.etapes[xkey][vkey].value" class="text-xs appearance-none block w-full text-grey-darker rounded-sm"></textarea>
                            </div>
                        </template>
                        <template v-else-if="option.type === 'date'">
                            <div class="text-xs my-2">
                                <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <input :id="'option_'+option.id" v-model="form.etapes[xkey][vkey].value" type="date" :name="option.name" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4">
                            </div>
                        </template>
                        <template v-else-if="option.type === 'number'">
                            <div class="text-xs my-2">
                                <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <input :id="'option_'+option.id" v-model.number="form.etapes[xkey][vkey].value" type="number" :name="option.name" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4">
                            </div>
                        </template>
                        <template v-else-if="option.type === 'checkbox'">
                            <div class="text-xs my-2">
                                <label class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <div class="flex flex-col">
                                    <template v-for="(enfant) in option.enfants">
                                        <template v-if="enfant.type === 'label'">
                                            <label class="block text-center text-sm font-bold text-gray-600 py-2" v-html="__(enfant.name)"></label>
                                        </template>
                                        <template v-else>
                                            <label class="inline-flex mt-3 cursor-pointer">
                                                <input v-model="form.etapes[xkey][vkey].value" :value="enfant.id" type="checkbox" class="form-checkbox h-5 w-5 text-cavilam-primary cursor-pointer">
                                                <span class="ml-2 text-gray-800" v-html="__(enfant.name)"></span>
                                            </label>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="option.type === 'radio'">
                            <div class="text-xs my-2">
                                <label class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <div class="flex flex-col">
                                    <template v-for="(enfant) in option.enfants">
                                        <template v-if="enfant.type === 'label'">
                                            <label class="block text-sm font-bold text-gray-600 py-2" v-html="__(enfant.name)"></label>
                                        </template>
                                        <template v-else>
                                            <label class="inline-flex mt-3 cursor-pointer" v-if="enfant.est_actif === 1">
                                                <input v-model="form.etapes[xkey][vkey].value" :value="enfant.id" type="radio" class="form-radio h-5 w-5 text-cavilam-primary cursor-pointer">
                                                <span class="ml-2 text-gray-800" v-html="__(enfant.name).replace('__TARIF__', parseFloat(enfant.montant).toFixed(0))"></span>
                                            </label>
                                            <div v-if="etape.id == 1 && form.etapes[0][3]">
                                                <div v-if="option.id === 13 && form.etapes[0][3].id === 13 && form.etapes[0][3].value === 14 && enfant.id === 14">
                                                    <span class="block text-center text-sm font-semibold text-gray-600 py-2" v-html="__('etape_hebergement_facturation')"></span>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="option.type === 'select'">
                            <div class="text-xs my-2">
                                <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                                <select :id="'option_'+option.id" v-model="form.etapes[xkey][vkey].value" class="block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4 md:w-full">
                                    <option :value="null" disabled>{{ __('choisir...') }}</option>
                                    <template v-for="(enfant) in option.enfants">
                                        <option :value="enfant.id" v-html="__(enfant.name)"></option>
                                    </template>
                                </select>
                            </div>
                        </template>
                        <template v-else-if="option.type === 'submit' && (etapeActuelle+1) < etapes.length">
                            <div class="my-4 text-center">
                                <button class="inline-block px-6 py-2 text-xs
                                    font-medium leading-6 text-center text-white
                                    uppercase transition bg-cavilam-primary rounded
                                    shadow ripple hover:shadow-lg hover:bg-blue-800
                                    focus:outline-none"
                                    @click="validerEtape">
                                    Valider
                                </button>
                                <div class="text-center" v-if="showError">
                                    <span class="font-medium tracking-wide text-red-500 text-xs my-2 font-semibold">
                                        {{ __('veuillez_remplir_correctement_toutes_les_informations') }}
                                    </span>
                                </div>
                            </div>
                        </template>
                    </template>
                </template>
            </div>
            <div class="flex my-2">
                <div class="w-1/3">
                    <button v-if="etapeActuelle > 0" class="inline-block px-6 py-2 text-xs font-medium leading-6
                        text-center text-white uppercase transition bg-yellow-400 rounded
                        shadow ripple hover:shadow-lg hover:bg-yellow-300
                        focus:outline-none" @click="etapePrecedente">
                        <i class="fas fa-undo"></i> {{ __('precedent') }}
                    </button>
                </div>
                <div v-if="(etapeActuelle+1) >= etapes.length && showSubmit" class="w-1/3 text-center">
                    <breeze-button @click="validerEtape"
                        :class="{ 'opacity-25': form.processing || !peutEnvoyer }"
                        :disabled="form.processing || !peutEnvoyer">
                        {{ __('envoyer') }}
                    </breeze-button>
                    <div class="text-center" v-if="showError">
                        <span class="font-medium tracking-wide text-red-500 text-xs my-2 font-semibold">
                            {{ __('veuillez_remplir_correctement_toutes_les_informations') }}
                        </span>
                    </div>
                </div>
                <div v-else-if="!etape.est_obligatoire" class="w-1/3 text-right">
                    <button class="inline-block px-6 py-2 text-xs font-medium
                        leading-6 text-center text-white uppercase transition
                        bg-cavilam-secondary rounded shadow ripple hover:shadow-lg
                        hover:bg-green-300 focus:outline-none"
                        @click="passerEtape">
                        {{ __('passer') }} <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
            <p class="text-sm my-2">{{ __('etape_'+etape.nom+'_mentions') }}</p>
            <p class="text-xs text-gray-500 text-right">Les champs marqués d'un <sup class="text-red-600">*</sup> sont obligatoires.</p>
        </div>
    </template>
    <template v-if="isSubmitted">
        <div class="w-44 text-center m-auto">
            <svg id="L9" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 viewBox="0 0 100 100" xml:space="preserve">
                <path fill="#003768" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                    <animateTransform
                      attributeName="transform"
                      attributeType="XML"
                      type="rotate"
                      dur="1s"
                      from="0 50 50"
                      to="360 50 50"
                      repeatCount="indefinite" />
              </path>
            </svg>
        </div>
    </template>
</template>

<script>
import App from '@/Layouts/App'
import BreezeButton from '@/Components/Button'

export default {
    name: "Etapes",
    layout: App,
    components: {
        BreezeButton,
    },
    props: {
        type: Object,
        categorie: Object,
        produit: Object,
        produitBis: Object,
        programmes: Array,
        niveau: Object,
        nbSemaines: Number,
        etapes: Array,
    },
    data: function () {
        return {
            peutEnvoyer: true,
            form: this.$inertia.form({
                produit: this.produit.id,
                programmes: this.programmes,
                niveau: this.niveau,
                nbSemaines: this.nbSemaines,
                etapes: [],
            }),
            etapeNb: 0,
            showError: false,
            isSubmitted: false,
        }
    },
    created() {
        for(let etape in this.etapes) {
            this.form.etapes[etape] = [];
            for(let option in this.etapes[etape].options) {
                this.form.etapes[etape].push(this.etapes[etape].options[option]);
                if(this.form.etapes[etape][option].type === 'checkbox')
                    this.form.etapes[etape][option].value = [];
                }
            }
    },
    mounted() {
        // On empêche l'user de quitter la page si le form a pas été envoyé
        /*window.onbeforeunload = function (e) {
            if(!this.isSubmitted) {
                var message = "You have not saved your changes.", e = e || window.event;
                if (e) {
                    e.returnValue = message;
                }
                return message;
            }
        }*/
    },
    methods: {
        submit() {
            this.isSubmitted = true;
            dataLayer.push({'event': 'TM-form-etape'});
            this.form.post(this.route('inscription.etapes.enregistrer', {
                'type': this.type.slug,
                'categorie': this.categorie.slug,
                'produit': this.produit.slug,
            }));
        },
        validerEtape() {
            for(let option in this.form.etapes[this.etapeNb]) {
                let uneOption = this.form.etapes[this.etapeNb][option];
                if(uneOption.type === 'submit')
                    continue;
                if(!this.form.etapes[this.etapeNb][option].value
                    && this.form.etapes[this.etapeNb][option].est_requis
                    && this.showOption[uneOption.etape_id][uneOption.id]) {
                    this.showError = true;
                    return;
                }
            }

            this.showError = false;

            if(this.etapeNb < this.etapes.length)
                this.etapeNb++;

            let afficherEtape = false;

            // On vérifie que l'étape suivante peut être affichée
            while(!afficherEtape && this.etapeActuelle < this.etapes.length) {
                if(!this.etapes[this.etapeActuelle].conditions.length)
                    break;

                for(let key in this.etapes[this.etapeActuelle].conditions) {
                    let condition = this.etapes[this.etapeActuelle].conditions[key];
                    for(let line in this.etapes) {
                        let parentOption = this.form.etapes[line].find(option => {
                            return option.id === condition.parent_option_id;

                        });

                        if(parentOption) {
                            if(parseInt(parentOption.value) === parseInt(condition.enfant_option_id))
                                afficherEtape = true;
                            else
                                this.etapeNb++;

                            break;
                        }
                    }
                }
            }

            if(this.etapeActuelle >= this.etapes.length)
                this.submit();
        },
        passerEtape() {
            for(let option in this.form.etapes[this.etapeNb]) {
                if(this.form.etapes[this.etapeNb][option].type === 'submit')
                    continue;
                this.form.etapes[this.etapeNb][option].value = null;
            }
            if(this.etapeNb < this.etapes.length)
                this.etapeNb++;
        },
        etapePrecedente() {
            if(this.etapeNb > 0)
                this.etapeNb--;
        },
        choisirOption(etapeIndex, optionParentIndex, idOptionEnfant) {
            this.form.etapes[etapeIndex][optionParentIndex].value = idOptionEnfant;

            if((this.etapeActuelle+1) >= this.etapes.length && !this.showSubmit) {
                this.etapeNb++;
                this.submit();
            }
            else
                this.etapeNb++;
        },
        getOption(etapeIndex, OptionParentIndex, idOptionEnfant) {
            return this.form.etapes[etapeIndex][OptionParentIndex].enfants.find(option => {
                return option.id === idOptionEnfant;
            });
        },
        comparerExpression(expression, condition1) {
            if(!expression || !condition1)
                return false;

            expression = expression.split(':');
            if(expression && expression.length === 2) {
                let condition2 = '';

                // Alors c'est une date, sinon c'est une valeur quelconque
                if(expression[1].includes('NOW')) {
                    let jours = expression[1].match(/[+-]*[0-9]+/g);
                    if(jours && jours.length)
                        jours = parseInt(jours[0]);
                    else
                        jours = 0;
                    condition2 = (new Date()).setDate((new Date()).getDate() + jours);
                    condition1 = (new Date(condition1)).getTime();
                } else {
                    condition2 = expression[1];
                }

                switch (expression[0]) {
                    case 'GREATER':
                        return (condition1 > condition2);
                    case 'LOWER':
                        return (condition1 < condition2);
                    case 'GREATER_EQUAL':
                        return (condition1 >= condition2);
                    case 'LOWER_EQUAL':
                        return (condition1 <= condition2);
                    default:
                        return (condition1 === condition2);
                }
            }

            return false;
        },
    },
    computed: {
        showSubmit() {
            for(let option in this.form.etapes[this.etapeNb]) {
                if(this.form.etapes[this.etapeNb][option].type === 'button')
                    return false;
            }

            return true;
        },
        etapeActuelle() {
            return this.etapeNb;
        },
        showOption() {
            let displayOption = {};

            for(let line in this.form.etapes) {
                let etape = this.etapes[line];
                displayOption[etape.id] = {};
                for(let optionIndex in etape.options) {
                    let option = etape.options[optionIndex];
                    displayOption[etape.id][option.id] = true;
                    for(let row in option.conditions) {
                        let condition = option.conditions[row];
                        let parentOption = this.form.etapes[line].find(option => {
                            return option.id === condition.parent_option_id;
                        });

                        if(!this.form.etapes || !this.form.etapes[line] || !parentOption ||
                            (
                                !this.comparerExpression(condition.expression, parentOption.value) &&
                                parseInt(parentOption.value) !== parseInt(condition.enfant_option_id)
                            )
                        ) {
                            displayOption[etape.id][option.id] = false;
                            option.value = null;
                            break;
                        }
                    }
                }
            }
            return displayOption;
        },
        getTotalOptions() {
            let total = 0.0;

            for(let eKey in this.form.etapes) {
                let etape = this.form.etapes[eKey];
                for(let oKey in etape) {
                    let option = etape[oKey];

                    if(!option || !option.value)
                        continue;

                    if(option.enfants && option.enfants.length) {
                        if(!this.getOption(eKey, oKey, option.value) || this.getOption(eKey, oKey, option.value).montant <= 0)
                            continue;

                        total += parseFloat(this.getOption(eKey, oKey, option.value).montant);
                    } else {
                        if(option.montant <= 0)
                            continue;

                        if(option.type === 'number') {
                            total += parseFloat(option.value * option.montant);
                        } else {
                            total += parseFloat(option.montant);
                        }
                    }
                }
            }

            return total;
        }
    }
}
</script>

<style scoped>

</style>
